import { render, staticRenderFns } from "./dialog-create-info.vue?vue&type=template&id=1706ef86&scoped=true"
import script from "./dialog-create-info.vue?vue&type=script&lang=js"
export * from "./dialog-create-info.vue?vue&type=script&lang=js"
import style0 from "./dialog-create-info.vue?vue&type=style&index=0&id=1706ef86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1706ef86",
  null
  
)

export default component.exports